import api from './authService'
import { crearErrorAplicacionApi } from './apiError'

export interface EventoAuditoriaAdmin {
  id_evento: number
  id_actor_usuario?: number | null
  actor_email?: string | null
  actor_rol?: string | null
  accion: string
  entidad_tipo: string
  entidad_id?: string | null
  descripcion?: string | null
  ip_origen?: string | null
  metadata?: Record<string, any> | null
  fecha_evento?: string | null
}

export interface FiltrosAuditoriaAdmin {
  accion?: string
  actor?: string
  entidad_tipo?: string
  entidad_id?: string
  ip_origen?: string
  fecha_desde?: string
  fecha_hasta?: string
  limite?: number
  offset?: number
}

export interface RespuestaAuditoriaAdmin {
  items: EventoAuditoriaAdmin[]
  total: number
  limite: number
  offset: number
}

export interface OpcionCatalogoAuditoria {
  valor: string
  label: string
}

export interface CatalogoAuditoriaAdmin {
  acciones: OpcionCatalogoAuditoria[]
  entidades: OpcionCatalogoAuditoria[]
}

export const auditoriaAdminService = {
  async obtenerCatalogo(): Promise<CatalogoAuditoriaAdmin> {
    try {
      const response = await api.get('/api/admin/auditoria/catalogo')
      return response.data
    } catch (error: unknown) {
      throw crearErrorAplicacionApi(error, 'Error al obtener el catálogo de auditoría')
    }
  },

  async obtenerEventos(filtros: FiltrosAuditoriaAdmin = {}): Promise<RespuestaAuditoriaAdmin> {
    try {
      const params = new URLSearchParams()
      if (filtros.accion) params.append('accion', filtros.accion)
      if (filtros.actor) params.append('actor', filtros.actor)
      if (filtros.entidad_tipo) params.append('entidad_tipo', filtros.entidad_tipo)
      if (filtros.entidad_id) params.append('entidad_id', filtros.entidad_id)
      if (filtros.ip_origen) params.append('ip_origen', filtros.ip_origen)
      if (filtros.fecha_desde) params.append('fecha_desde', filtros.fecha_desde)
      if (filtros.fecha_hasta) params.append('fecha_hasta', filtros.fecha_hasta)
      if (typeof filtros.limite === 'number') params.append('limite', String(filtros.limite))
      if (typeof filtros.offset === 'number') params.append('offset', String(filtros.offset))

      const query = params.toString()
      const response = await api.get(`/api/admin/auditoria${query ? `?${query}` : ''}`)
      return response.data
    } catch (error: unknown) {
      throw crearErrorAplicacionApi(error, 'Error al obtener la bitácora de auditoría')
    }
  },

  async exportarEventosCsv(filtros: FiltrosAuditoriaAdmin = {}): Promise<Blob> {
    try {
      const params = new URLSearchParams()
      if (filtros.accion) params.append('accion', filtros.accion)
      if (filtros.actor) params.append('actor', filtros.actor)
      if (filtros.entidad_tipo) params.append('entidad_tipo', filtros.entidad_tipo)
      if (filtros.entidad_id) params.append('entidad_id', filtros.entidad_id)
      if (filtros.ip_origen) params.append('ip_origen', filtros.ip_origen)
      if (filtros.fecha_desde) params.append('fecha_desde', filtros.fecha_desde)
      if (filtros.fecha_hasta) params.append('fecha_hasta', filtros.fecha_hasta)

      const query = params.toString()
      const response = await api.get(`/api/admin/auditoria/exportar${query ? `?${query}` : ''}`, {
        responseType: 'blob',
      })
      return response.data
    } catch (error: unknown) {
      throw crearErrorAplicacionApi(error, 'Error al exportar la bitácora de auditoría')
    }
  },
}
